import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-choice",
  "use": "icon-choice-usage",
  "viewBox": "0 0 1040 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1040 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-choice\"><path d=\"M1023.829108 474.655464 474.574622 1023.937578l549.255509 0L1023.830131 474.655464zM783.15977 979.731774l-96.895841-96.93268 36.335556-36.349883 60.560284 60.582797 169.567977-169.632445 36.335556 36.349883L783.15977 979.731774z\" p-id=\"2271\" fill=\"#2E8ED4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol